/**
 * 环境配置工具函数
 */

/**
 * 获取应用环境配置
 * 从环境变量中读取配置信息
 */
export function getAppEnvConfig() {
  const {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_API_HEAD_API_KEY,
    VITE_WX_APP_ID,
    VITE_GLOB_MAP_KEY,
    VITE_GLOB_UPLOAD_URL,
  } = import.meta.env;

  return {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_API_HEAD_API_KEY,
    VITE_WX_APP_ID,
    VITE_GLOB_MAP_KEY,
    VITE_GLOB_UPLOAD_URL,
  };
}

/**
 * 检查是否为开发环境
 */
export function isDev(): boolean {
  return import.meta.env.DEV;
}

/**
 * 检查是否为生产环境
 */
export function isProd(): boolean {
  return import.meta.env.PROD;
}

/**
 * 获取当前环境模式
 */
export function getMode(): string {
  return import.meta.env.MODE;
}

// 检查当前是否是助教端
export function isTeachMode(): boolean {
  return import.meta.env.VITE_APP_MODE === 'teach';
}
